const PaymentSummary = ({
  selectedAccount,
  amountValue,
  paymentMethod,
  total,
  formatCurrency,
  t = (text) => text,
}) => {
  return (
    <div className="p-4 rounded-xl bg-neutral-50 dark:bg-neutral-950 border border-neutral-200 dark:border-neutral-900">
      <h3 className="text-xs font-medium text-neutral-800 dark:text-neutral-200 mb-3">{t("Payment Summary")}</h3>
      <div className="space-y-2 text-xs">
        <div className="flex justify-between">
          <span className="text-neutral-600 dark:text-neutral-400">{t("Account")}:</span>
          <span className="text-neutral-900 dark:text-neutral-200 font-medium">{selectedAccount.name}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-neutral-600 dark:text-neutral-400">{t("Amount")}:</span>
          <span className="text-neutral-900 dark:text-neutral-200 font-medium">{formatCurrency(amountValue)}</span>
        </div>

        <div className="flex justify-between">
          <span className="text-neutral-600 dark:text-neutral-400">{t("Payment Method")}:</span>
          <span className="text-neutral-900 dark:text-neutral-200 font-medium">
            {paymentMethod === "creditCard"
              ? t("Credit Card")
              : paymentMethod === "bankTransfer"
                ? t("Bank Transfer")
                : paymentMethod === "payoneer"
                  ? t("Payoneer")
                  : paymentMethod === "paypal"
                    ? t("PayPal")
                    : t("USDT")}
          </span>
        </div>

      </div>
    </div>
  )
}

export default PaymentSummary
